import React from 'react';
import './AdminView.scss';
import AdminUsers from "./AdminUsers/AdminUsers";
import AdminQuizes from './AdminQuizes/AdminQuizes';
import AdminLibrary from './AdminLibrary/AdminLibrary';
import AdminTasks from './AdminTasks/AdminTasks';
import AdminDataTask from './AdminTasks/AdminDataTask/AdminDataTask';

const AdminView = (props) => {
   
        const { dispatch} = props;
        
        return (
            
            <div className="AdminView">
                    {(props.viewUsers && (props.authData.userRole[0].role_id ===1))? <AdminUsers 
                    adminUsersState={props.adminUsersState}
                    viewUsers={props.viewUsers}
                    dispatch={dispatch} 
                    /> : null}
                     <AdminQuizes 
                    authData={props.authData}
                    viewQuizers={props.viewQuizers}
                    handleAdminQuizesView={props.handleAdminQuizesView}
                    adminState={props.adminState}
                    userId={props.userId}
                    dispatch={dispatch}
                    /> 
                    {props.viewLibrary ? <AdminLibrary
                    viewLibrary={props.viewLibrary}
                    libraryData={props.libraryData}
                    adminState={props.adminState}
                    dispatch={dispatch}
                    /> : null}
                   {props.viewTasks? <AdminTasks
                   viewTasks={props.viewTasks} 
                   dispatch={dispatch}
                   handleAdminTasksView={props.handleAdminTasksView}
                   authData={props.authData}
                   tasksDataMain={props.tasksDataMain} 
                   /> : null}
                  {props.adminState.adminDataTaskView && <AdminDataTask
                  dispatch={dispatch}
                  handleAdminTasksView={props.handleAdminTasksView}
                  tasksDataMain={props.tasksDataMain}
                  adminState={props.adminState} 
                  />}
                    
                    


                
            </div>
        )
    
}
export default AdminView;